// TODO - this file might be remnoved in future. Added a few mappings to avoid errors in nearest future, in case of usage.
import { IconName } from '../../lib/Icon/IconsProvider';

type IconsMap = { [icon in string]: IconName | undefined };

const fallbackIcons: IconsMap = {
  'far fa-comment': 'comment',
  'fas fa-phone': 'phone',
  'fas fa-envelope': 'envelope',
  'fas fa-chevron-right': 'chevron-right',
  'fas fa-chevron-down': 'chevron-down',
  'fas fa-sliders-h': 'sliders-h',
  'fas fa-search': 'search',
  'fas fa-sort-amount-up': 'sort-amount-up',
  'fas fa-sort-amount-down': 'sort-amount-down',
  'fas fa-chart-area': 'chart-area',
  'far fa-file': 'file-pdf',
  'fas fa-download': 'file-download',
  'fas fa-house-damage': 'house-damage',
  'fas fa-check': 'check',
  'fas fa-file-excel': 'file-excel',
  // Account Settings accordions
  'fas fa-user': 'user',
  'fas fa-address-card': 'address-card',
  'fas fa-tv': 'tv',
  'fas fa-desktop': 'desktop',
  'fas fa-paper-plane': 'paper-plane',
  'fas fa-file-alt': 'file-alt',
  'fas fa-id-card': 'id-card',
  // Term and Conditions icon
  'fas fa-print': 'print',
};

export const getFallbackIcon = (icon: string) => {
  let foundIcon = fallbackIcons[icon];
  if (foundIcon) {
    return foundIcon;
  }

  foundIcon = fallbackIcons[`fa-${icon}`];
  if (foundIcon) {
    return foundIcon;
  }

  foundIcon = fallbackIcons[`far fa-${icon}`];
  if (foundIcon) {
    return foundIcon;
  }

  foundIcon = fallbackIcons[`fas fa-${icon}`];
  if (foundIcon) {
    return foundIcon;
  }
};
